export const ariaLabel = (state: UI.FormfieldState, label: string): string | null => {
	return state?.isHidden ? label : null;
};
